// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"de171724","651":"28d4e854"}[chunkId] + ".chunk.js";
};